import { Box, CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    padding: theme.spacing(6.25),
    textAlign: "center",
    border: "1px solid #e1e1e3",
    backgroundColor: theme.custom.palette.softWhite.main,
  },
}));

const LoadingTable: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <CircularProgress size={60} />
    </Box>
  );
};

export default LoadingTable;
